module.exports = __webpack_public_path__ + "static/googlePlay-8b491c7925ac55fb22f5209842128def.png";